(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /*  Helpers                                                           */
  /* ------------------------------------------------------------------ */

  function getKlaviyoCompanyId() {
    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src;
      var pathMatch = src.match(/\/js\/([A-Za-z0-9]{6})\//);
      if (pathMatch) return pathMatch[1];
      var queryMatch = src.match(/company_id=([A-Za-z0-9]{6})/);
      if (queryMatch) return queryMatch[1];
    }
    if (window.klaviyo && window.klaviyo.companyId) return window.klaviyo.companyId;
    console.error('Swarm Registration: Could not detect Klaviyo company ID');
    return null;
  }

  function regKey(city, date) {
    return ('swarm_reg_' + city + '_' + date).toLowerCase().replace(/[^a-z0-9]/g, '_');
  }

  function markAsRegistered(card) {
    card.classList.add('swarm-registered');
    var btn = card.querySelector('.swarm-register-btn');
    var badge = card.querySelector('.swarm-registered-badge');
    if (btn) btn.style.display = 'none';
    if (badge) badge.style.display = '';
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  var RSVP_CAPI_ENDPOINT = 'https://attaquer-rsvp-capi.jonathan-24f.workers.dev/rsvp';

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[2]) : '';
  }

  function newEventId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'rsvp_' + Date.now() + '_' + Math.random().toString(16).slice(2);
  }

  function sendRsvpConversion(series, ride, person) {
    if (window.__isBot) return;
    try {
      fetch(RSVP_CAPI_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          event_id: newEventId(),
          email: person.email,
          first_name: person.firstName,
          last_name: person.lastName,
          series: series,
          city: ride.city,
          ride_date: ride.date,
          ride_date_display: ride.dateDisplay,
          event_source_url: window.location.href,
          fbp: readCookie('_fbp'),
          fbc: readCookie('_fbc')
        })
      }).catch(function () {});
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ */
  /*  Focus trap                                                        */
  /* ------------------------------------------------------------------ */

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function trapFocus(e) {
    var modal = document.querySelector('.swarm-modal');
    if (!modal) return;
    var focusable = modal.querySelectorAll(FOCUSABLE);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Init                                                              */
  /* ------------------------------------------------------------------ */

  function init() {
    var overlay = document.getElementById('swarm-modal-overlay');
    if (!overlay) return;
    if (overlay.dataset.swarmInit) return;
    overlay.dataset.swarmInit = 'true';

    var config = {
      companyId: overlay.dataset.companyId || getKlaviyoCompanyId(),
      listId: overlay.dataset.listId,
      waiverVersion: overlay.dataset.waiverVersion,
      series: overlay.dataset.series || 'swarm'
    };

    var currentCard = null;
    var currentRide = {};

    /* ---- DOM refs ---- */
    var formView      = document.getElementById('swarm-form-view');
    var successView   = document.getElementById('swarm-success');
    var cityEl        = document.getElementById('swarm-modal-city');
    var dateEl        = document.getElementById('swarm-modal-date');
    var detailsEl     = document.getElementById('swarm-modal-details');
    var form          = document.getElementById('swarm-reg-form');
    var errorEl       = document.getElementById('swarm-form-error');
    var firstNameIn   = document.getElementById('swarm-first-name');
    var lastNameIn    = document.getElementById('swarm-last-name');
    var emailIn       = document.getElementById('swarm-email');
    var waiverCheck   = document.getElementById('swarm-waiver-check');
    var submitBtn     = document.getElementById('swarm-submit-btn');
    var btnText       = submitBtn.querySelector('.swarm-btn-text');
    var btnLoading    = submitBtn.querySelector('.swarm-btn-loading');
    var successMsg    = document.getElementById('swarm-success-msg');
    var doneBtn       = overlay.querySelector('.swarm-success-done');
    var closeBtn      = overlay.querySelector('.swarm-modal__close');

    /* ---- Open modal ---- */
    function openModal(cardEl) {
      currentCard = cardEl;
      var d = cardEl.dataset;
      currentRide = {
        city: d.city || '',
        date: d.date || '',
        dateDisplay: d.dateDisplay || '',
        time: d.time || '',
        distance: d.distance || '',
        meeting: d.meeting || '',
        parkup: d.parkup || '',
        leaderName: d.leaderName || '',
        leaderEmail: d.leaderEmail || '',
        rideMonth: d.rideMonth || '',
        stravaRoute: d.stravaRoute || ''
      };

      cityEl.textContent = currentRide.city;
      dateEl.textContent = currentRide.dateDisplay;

      var details = '';
      if (currentRide.time) details += '<p><strong>Time:</strong> ' + escHtml(currentRide.time) + '</p>';
      if (currentRide.distance) details += '<p><strong>Distance:</strong> ' + escHtml(currentRide.distance) + '</p>';
      if (currentRide.meeting) details += '<p><strong>Meeting point:</strong> ' + escHtml(currentRide.meeting) + '</p>';
      if (currentRide.parkup) details += '<p><strong>Park up:</strong> ' + escHtml(currentRide.parkup) + '</p>';
      detailsEl.innerHTML = details;

      form.reset();
      waiverCheck.checked = false;
      submitBtn.disabled = true;
      errorEl.style.display = 'none';
      errorEl.textContent = '';
      btnText.style.display = '';
      btnLoading.style.display = 'none';
      formView.style.display = '';
      successView.style.display = 'none';

      overlay.style.display = '';
      requestAnimationFrame(function () { overlay.classList.add('swarm-modal--open'); });
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', trapFocus);
      firstNameIn.focus();
    }

    function escHtml(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }

    /* ---- Close modal ---- */
    function closeModal() {
      overlay.classList.remove('swarm-modal--open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', trapFocus);
      setTimeout(function () { overlay.style.display = 'none'; }, 300);
    }

    closeBtn.addEventListener('click', closeModal);
    doneBtn.addEventListener('click', closeModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.style.display !== 'none') closeModal();
    });

    /* ---- Validation ---- */
    function validateForm() {
      var valid =
        firstNameIn.value.trim().length > 0 &&
        isValidEmail(emailIn.value.trim()) &&
        waiverCheck.checked;
      submitBtn.disabled = !valid;
    }

    firstNameIn.addEventListener('input', validateForm);
    emailIn.addEventListener('input', validateForm);
    waiverCheck.addEventListener('change', validateForm);

    /* ---- Submit ---- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var firstName = firstNameIn.value.trim();
      var lastName = lastNameIn.value.trim();
      var email = emailIn.value.trim();

      if (!firstName) { showError('Please enter your first name.'); return; }
      if (!isValidEmail(email)) { showError('Please enter a valid email address.'); return; }
      if (!waiverCheck.checked) { showError('Please accept the ride waiver to continue.'); return; }
      if (!config.companyId) { showError('Registration is temporarily unavailable. Please try again later.'); return; }

      submitBtn.disabled = true;
      btnText.style.display = 'none';
      btnLoading.style.display = '';
      errorEl.style.display = 'none';

      var headers = { 'Content-Type': 'application/json', 'revision': '2026-07-15' };
      var ride = currentRide;
      var baseUrl = 'https://a.klaviyo.com/client/';

      var subscribeBody = JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Swarm Ride Registration',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  last_name: lastName
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: config.listId
              }
            }
          }
        }
      });

      var eventBody = JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: {
              data: { type: 'metric', attributes: { name: 'Registered for Ride' } }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  last_name: lastName,
                  properties: {
                    waiver_accepted: true,
                    waiver_accepted_date: new Date().toISOString(),
                    waiver_version: config.waiverVersion,
                    last_swarm_city: ride.city,
                    next_swarm_ride_date: ride.date
                  }
                }
              }
            },
            unique_id: (email + '_' + ride.city + '_' + ride.date).toLowerCase().replace(/[^a-z0-9]/g, '_'),
            properties: {
              ride_city: ride.city,
              ride_date: ride.date,
              ride_time: ride.time,
              distance: ride.distance,
              meeting_point: ride.meeting,
              park_up: ride.parkup,
              ride_month: ride.rideMonth,
              ride_leader_name: ride.leaderName,
              ride_leader_email: ride.leaderEmail,
              strava_route: ride.stravaRoute
            }
          }
        }
      });

      var profileBody = JSON.stringify({
        data: {
          type: 'profile',
          attributes: {
            email: email,
            first_name: firstName,
            last_name: lastName,
            properties: {
              waiver_accepted: true,
              waiver_accepted_date: new Date().toISOString(),
              waiver_version: config.waiverVersion,
              last_swarm_city: ride.city,
              next_swarm_ride_date: ride.date,
              next_swarm_ride_time: ride.time,
              next_swarm_meeting_point: ride.meeting,
              next_swarm_distance: ride.distance,
              next_swarm_park_up: ride.parkup,
              next_swarm_strava_route: ride.stravaRoute
            }
          }
        }
      });

      var callNames = ['subscribe', 'event', 'profile'];

      console.log('[Swarm] Sending registration — company:', config.companyId, 'list:', config.listId, 'email:', email);

      Promise.all([
        fetch(baseUrl + 'subscriptions/?company_id=' + config.companyId, {
          method: 'POST', headers: headers, body: subscribeBody
        }),
        fetch(baseUrl + 'events/?company_id=' + config.companyId, {
          method: 'POST', headers: headers, body: eventBody
        }),
        fetch(baseUrl + 'profiles/?company_id=' + config.companyId, {
          method: 'POST', headers: headers, body: profileBody
        })
      ])
        .then(function (responses) {
          var hasError = false;
          responses.forEach(function (r, i) {
            var ok = r.ok || r.status === 202;
            console.log('[Swarm]', callNames[i], '→', r.status, ok ? '✓' : '✗');
            if (!ok) {
              hasError = true;
              r.text().then(function (body) { console.error('[Swarm]', callNames[i], 'error body:', body); });
            }
          });
          var subOk = responses[0].ok || responses[0].status === 202;
          if (subOk) {
            onSuccess(ride, { email: email, firstName: firstName, lastName: lastName });
          } else {
            showError('Registration failed. Please check your email and try again.');
            submitBtn.disabled = false;
            btnText.style.display = '';
            btnLoading.style.display = 'none';
          }
        })
        .catch(function (err) {
          console.error('[Swarm] Network error:', err);
          showError('Registration failed. Please check your connection and try again.');
          submitBtn.disabled = false;
          btnText.style.display = '';
          btnLoading.style.display = 'none';
        });
    });

    function onSuccess(ride, person) {
      sendRsvpConversion(config.series, ride, person);
      localStorage.setItem(regKey(ride.city, ride.date), 'true');
      if (currentCard) markAsRegistered(currentCard);

      successMsg.textContent = 'You\'re registered for the ' + ride.city + ' ride on ' + ride.dateDisplay + '. See you there!';
      formView.style.display = 'none';
      successView.style.display = '';
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.style.display = '';
    }

    /* ---- Register button listeners ---- */
    document.querySelectorAll('.swarm-register-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.closest('.swarm-ride'));
      });
    });

    /* ---- Restore registered state from localStorage ---- */
    document.querySelectorAll('.swarm-ride').forEach(function (card) {
      var key = regKey(card.dataset.city, card.dataset.date);
      if (localStorage.getItem(key)) markAsRegistered(card);
    });
  }

  /* Run immediately if DOM is already ready, otherwise wait */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when section is loaded/re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', init);
})();
